import React, { useImperativeHandle } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
	appMainContent: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		boxSizing: 'border-box',
	},
}));

const CmtContent = React.forwardRef((props, ref) => {
	const { children } = props;

	useImperativeHandle(ref, () => ({}));

	const contentRef = React.createRef();
	const classes = useStyles();

	return (
		<Box ref={contentRef} className={clsx(classes.appMainContent, 'Cmt-appMainContent')} bgcolor='background.main'>
			{children}
		</Box>
	);
});

export default CmtContent;
CmtContent.defaultProps = {
	name: 'LayoutContent',
};
